// Utility to build page URLs from page names (mirrors original base44 behaviour)
export function createPageUrl(pageName) {
  return "/" + String(pageName).replace(/ /g, "-");
}
